import $ from "jquery";

const toggleClassSlide = () => {
  const init = () => {
    execute();
  };

  const execute = () => {
    const el = {
      button: ".js-toggle-class-slide",
    };

    $(document).on("click", el.button, function () {
      const targetEl = $(this).data("for");
      $(targetEl).slideToggle();
    });
  };

  init();
};

try {
  toggleClassSlide();
} catch (error) {
  console.error("toggleClass: ", toggleClassSlide);
}
